export default {
  tight: 1.25,
  default: 1.5,
};
